/**
 * @author Muhammad Hamza
 * @datetime June, 7 2022
 * @description: This is ConfirmRemoveDialogComponent which will be called in case
 *               user try to remove some impportant details. This Modal component
 *               will prompt user to decide the flow by Yes or No button
 */

import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

@Component({
  selector: 'app-confirm-remove-dialog',
  templateUrl: './confirm-remove-dialog.component.html',
  styleUrls: ['./confirm-remove-dialog.component.scss'],
})
export class ConfirmRemoveDialogComponent {
  title: string;
  headingText: string;
  bodyText: string;
  footerText: string;
  showCloseBtn: boolean = false;

  readonly CONSTANTS = CONSTANTS;
  readonly LANG_CONST = LANG_CONST;

  constructor(
    public dialogRef: MatDialogRef<ConfirmRemoveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.headingText = data?.headingText;
    this.title = data?.title;
    this.bodyText = data?.bodyText;
    this.footerText = data?.footerText;
    this.showCloseBtn = data?.showCloseBtn || false;
  }

  /**
   * ## Accept Dialog
   * @description: This function called when user sure to delete the data and press yes
   * @input {none}
   * @output {void}
   */

  acceptDialog() {
    this.dialogRef?.close(true);
  }

  /**
   *  ## Reject Dialog
   * @description: This function called when user not sure to delete the data and press No
   * @input {none}
   * @output {void}
   */

  rejectDialog() {
    this.dialogRef?.close(false);
  }
}
